import { render, staticRenderFns } from "./Collectiondetails.vue?vue&type=template&id=35098a04&scoped=true"
import script from "./Collectiondetails.vue?vue&type=script&lang=js"
export * from "./Collectiondetails.vue?vue&type=script&lang=js"
import style0 from "./Collectiondetails.vue?vue&type=style&index=0&id=35098a04&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35098a04",
  null
  
)

export default component.exports